export default {
  title_text: '工单管理',
  sidebar_template: '工单模板'
}
